import { createActions } from 'redux-actions';

export const {
  emailExample: { sendEmail, emailSent },
}: any = createActions({
    EMAIL_EXAMPLE: {
        SEND_EMAIL: (data, sentFrom) => ({
            data,
            sentFrom,
        }),
        EMAIL_SENT: (data) => data,
    },
});



// WEBPACK FOOTER //
// ./src/Actions/emailExample.ts